module.exports = __webpack_public_path__ + "media/images/lb/391-73e1913634a17467214d76862de778ff.svg";